import { c as _c } from "react/compiler-runtime";
import { Icon, Title } from "@justhome/react-ui";
import { FathomEvent } from "@lib/constants";
import { useTrackEvent } from "@lib/hooks/useTrackEvent";
import clsx from "clsx";
import { FC } from "react";
import Slideshow from "../Slideshow";
import Swiper from "../Swiper";
import SwiperCard from "../SwiperCard";
import LeadWallForm, { LeadWallFormValue } from "./LeadWallForm";
import { Slide } from "./types";
export interface LeadWallProps {
  className?: string;
  title: string;
  description: string;
  listItems?: string[];
  moreText?: string;
  slides?: Slide[];
  onSubmit: (value: LeadWallFormValue) => void;
  isLoading: boolean;
  isError: boolean;
  onPrevious?: VoidFunction;
  defaultValues?: Partial<LeadWallFormValue>;
  isEmbedded?: boolean;
}
const LeadWall: FC<LeadWallProps> = t0 => {
  const $ = _c(37);
  const {
    className,
    title,
    description,
    listItems,
    moreText,
    slides,
    onSubmit,
    isLoading,
    isError,
    onPrevious,
    defaultValues,
    isEmbedded: t1
  } = t0;
  const isEmbedded = t1 === undefined ? false : t1;
  useTrackEvent(FathomEvent.LEAD_WALL_SEEN);
  const hasSlides = slides && slides.length > 0;
  let t2;
  if ($[0] !== className) {
    t2 = clsx("h-full m:grid grid-cols-12 gap items-center max-w-full", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = hasSlides ? "col-span-5" : "col-span-12";
  let t4;
  if ($[2] !== t3) {
    t4 = clsx(t3);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== title) {
    t5 = <Title className="hidden m:block text-h1 mb-3s">{title}</Title>;
    $[4] = title;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== description) {
    t6 = description && <p className="mb-2s text-body-2">{description}</p>;
    $[6] = description;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== moreText) {
    t7 = moreText && <p className="mb-2xs">{moreText}</p>;
    $[8] = moreText;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== listItems) {
    t8 = listItems && <ul className="hidden m:block text-body-2 mb-m space-y-xs">{listItems?.map(_temp)}</ul>;
    $[10] = listItems;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== hasSlides || $[13] !== slides) {
    t9 = hasSlides && <Swiper className="m:hidden my-2s -mx-s overflow-hidden">{slides.map(_temp2)}</Swiper>;
    $[12] = hasSlides;
    $[13] = slides;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== defaultValues || $[16] !== isEmbedded || $[17] !== isError || $[18] !== isLoading || $[19] !== onPrevious || $[20] !== onSubmit) {
    t10 = <LeadWallForm isEmbedded={isEmbedded} isError={isError} isLoading={isLoading} onSubmit={onSubmit} defaultValues={defaultValues} onPrevious={onPrevious} />;
    $[15] = defaultValues;
    $[16] = isEmbedded;
    $[17] = isError;
    $[18] = isLoading;
    $[19] = onPrevious;
    $[20] = onSubmit;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t4 || $[24] !== t5 || $[25] !== t6 || $[26] !== t7 || $[27] !== t8 || $[28] !== t9) {
    t11 = <div className={t4}>{t5}{t6}{t7}{t8}{t9}{t10}</div>;
    $[22] = t10;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== hasSlides || $[31] !== slides) {
    t12 = hasSlides && <div className="mb-3s col-span-6 col-start-7 hidden m:flex h-full max-h-[1000px]"><Slideshow>{slides.map(_temp3)}</Slideshow></div>;
    $[30] = hasSlides;
    $[31] = slides;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== t11 || $[34] !== t12 || $[35] !== t2) {
    t13 = <div className={t2}>{t11}{t12}</div>;
    $[33] = t11;
    $[34] = t12;
    $[35] = t2;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  return t13;
};
export default LeadWall;
function _temp(item) {
  return <li key={item} className="flex items-center gap-2xs"><Icon type="CheckSmall" size="24" className="text-primary-800 flex-none" />{item}</li>;
}
function _temp2(slide) {
  return <Swiper.Slide key={slide.title}><SwiperCard {...slide} /></Swiper.Slide>;
}
function _temp3(slide_0) {
  return <SwiperCard key={slide_0.title} {...slide_0} />;
}